import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnInit,
  ChangeDetectorRef,
  inject,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ClickOutsideDirective } from '../../directives/click-outside/click-outside.directive';
import { OnChanges, SimpleChanges } from '@angular/core';
export type MultiselectOption = Record<string, string>;

@Component({
  selector: 'app-multiselect-filter',
  standalone: true,
  imports: [FormsModule, CommonModule, ClickOutsideDirective],
  templateUrl: './multiselect-filter.component.html',
  styleUrl: './multiselect-filter.component.scss',
})
export class MultiselectFilterComponent implements OnInit, OnChanges {
  private cdr = inject(ChangeDetectorRef);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input({ required: true }) options!: any[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() selectedValues: any[] = [];
  @Input() placeholder = 'Select options';
  @Input() isDisabled = false;

  // Dynamic keys
  @Input() optionKey = 'option';
  @Input() valueKey = 'value';
  @Input() styleClass = '';
  @Input() fallBackLabel = false;

  @Output() apply = new EventEmitter<string[]>();

  isDropdownOpen = false;
  searchValue = '';

  filteredOptions: MultiselectOption[] = [];
  filteredSelectedValues: string[] = [];

  ngOnInit(): void {
    this.filteredOptions = [...this.options];
    this.filteredSelectedValues = [...this.selectedValues];
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['options'] && changes['options'].currentValue) {
      this.filteredOptions = [...changes['options'].currentValue];
    }

    if (changes['selectedValues'] && changes['selectedValues'].currentValue) {
      this.filteredSelectedValues = [...changes['selectedValues'].currentValue];
    }
  }

  toggleDropdown() {
    if (!this.isDisabled) {
      this.isDropdownOpen = !this.isDropdownOpen;

      if (this.isDropdownOpen) {
        this.filteredSelectedValues = [...this.selectedValues];
      }
    }
  }

  getOptionLabel(value: string): string {
    const found = this.options.find((o) => o[this.valueKey] === value);

    return found
      ? String(
          this.fallBackLabel
            ? found[this.optionKey] || found[this.valueKey]
            : found[this.optionKey],
        )
      : String(value);
  }

  getOptionValue(option: MultiselectOption): string {
    return option[this.valueKey] as string;
  }

  removeTag(value: string, event: MouseEvent | KeyboardEvent) {
    event.stopPropagation();
    this.selectedValues = this.filteredSelectedValues.filter(
      (v) => v !== value,
    );
    this.filteredSelectedValues = [...this.selectedValues];
    if (!this.isDropdownOpen) {
      this.onApply();
    }
  }

  onSearch(value: string) {
    this.searchValue = value.trim().toLowerCase();

    if (!value) {
      this.filteredOptions = [...this.options];
      return;
    }

    this.filteredOptions = this.options.filter((opt) =>
      String(opt[this.optionKey]).toLowerCase().includes(this.searchValue),
    );
  }

  onSelectOption(value: string) {
    if (this.filteredSelectedValues.includes(value)) {
      this.filteredSelectedValues = this.filteredSelectedValues.filter(
        (v) => v !== value,
      );
    } else {
      this.filteredSelectedValues = [...this.filteredSelectedValues, value];
    }
  }

  onSelectAll() {
    if (this.filteredSelectedValues.length === this.filteredOptions.length) {
      this.filteredSelectedValues = [];
    } else {
      this.filteredSelectedValues = this.filteredOptions.map((o) =>
        this.getOptionValue(o),
      );
    }
  }

  onClear() {
    this.filteredOptions = [...this.options];
    this.filteredSelectedValues = [];
    this.selectedValues = [];
    this.searchValue = '';
    this.onApply();
  }

  onApply() {
    this.selectedValues = [...this.filteredSelectedValues];
    this.apply.emit(this.selectedValues);
    this.isDropdownOpen = false;
  }

  onClickOutside() {
    this.isDropdownOpen = false;
    this.filteredSelectedValues = [...this.selectedValues];
    this.cdr.detectChanges();
  }
}
